// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoaderSpinner_loaderContainer__CvYg+","spinnerIcon":"LoaderSpinner_spinnerIcon__NTPVq","spin":"LoaderSpinner_spin__0FprM"};